function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// import {validation} from '@signiapp/helpers';
// import signerValidator from './signer.js';
import { format, set } from 'date-fns';
import { t } from "../../helpers/i18n";
export var validators = {
  documents: function documents(data) {
    var docs = data.documents;
    if (!(docs !== null && docs !== void 0 && docs.length)) {
      return {
        errors: [t('signorder_validation_no_documents')]
      };
    } else if (!docs.some(function (doc) {
      return data.signers.every(function (signer) {
        var _signer$data;
        return ((_signer$data = signer.data) === null || _signer$data === void 0 ? void 0 : _signer$data.signerRoles[doc.id]) === 'sign';
      });
    })) return {
      errors: [t('signorder_validation_no_signed_document')]
    };
  },
  // attachments: (data) => {
  //   const {attachments} = data;

  //   if (attachments.some((att) => data.signers.every((signer) => !signer.data?.signerRoles[att.id] === 'hide')))
  //     return {
  //       errors: [t('signorder_validation_only ')],
  //     };
  // },
  signers: function signers(data) {
    var _data$advanced;
    var signers = data.signers;
    if (!(signers !== null && signers !== void 0 && signers.length)) {
      return {
        errors: [t('signorder_validation_no_signers')]
      };
    } else if (((_data$advanced = data.advanced) === null || _data$advanced === void 0 ? void 0 : _data$advanced.stack) == 'green' && signers.some(function (s) {
      var _s$data, _s$data$signatureMeth;
      return ((_s$data = s.data) === null || _s$data === void 0 ? void 0 : (_s$data$signatureMeth = _s$data.signatureMethods) === null || _s$data$signatureMeth === void 0 ? void 0 : _s$data$signatureMeth.length) == 0;
    })) {
      return {
        errors: [t('signorder_validation_no_signing_method')]
      };
    }
  },
  title: function title(data) {
    var _data$metaData;
    var title = data === null || data === void 0 ? void 0 : (_data$metaData = data.metaData) === null || _data$metaData === void 0 ? void 0 : _data$metaData.title;
    if (!title) {
      return {
        errors: [t('signorder_field_title_validation_is_required')]
      };
    } else if (title.length < 4) {
      return {
        errors: [t('signorder_field_title_validation_minlength')]
      };
    }
  },
  expires: function expires(data, options) {
    if (!data.expires) {
      return;
    }
    try {
      var date = new Date(data.expires);
      var minExpirationDate = new Date(options.minExpirationDate);
      var maxExpirationDate = new Date(options.maxExpirationDate);
      if (date < set(minExpirationDate, {
        hours: 0,
        minutes: 0,
        seconds: 0
      })) {
        return {
          errors: [t('signorder_validation_expiration_too_soon')]
        };
      }
      if (date > maxExpirationDate) {
        return {
          errors: [t('signorder_validation_expiration_too_late', {
            maxExpirationDate: format(maxExpirationDate, 'dd.MM.yyyy')
          })]
        };
      }
    } catch (err) {
      return {
        errors: [t('validation_invalid_date_format')]
      };
    }
  }
};
var order = function order(data, options) {
  return Object.entries(validators).reduce(function (acc, curr) {
    var _curr = _slicedToArray(curr, 2),
      key = _curr[0],
      val = _curr[1];
    // const result = val(data[key]);
    var result = val(data, options);
    return result ? _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, result)) : acc;
  }, {});
};
export default order;